// extracted by mini-css-extract-plugin
module.exports = {"Toobar":"Toobar_Toobar__3EeRv","Logo":"Toobar_Logo__2FTq0","DesktopOnly":"Toobar_DesktopOnly__1MsZj"};